<template>
<div class="content">
    <div class="container-fluid">
    <div class="row">
        <div class="col-md-12">
        <update-leave>
        </update-leave> 
        </div>
    </div>  
    </div>
</div>
</template>
<script>
/* eslint-disable */
import updateLeave from './todo-update-leave'
export default {
    components: {
        updateLeave
    }
}
</script>
<style lang="scss">
</style>


// WEBPACK FOOTER //
// src/components/Dashboard/Views/bp-leave-management/base-update-leave.vue